export var TagItemStyles = function TagItemStyles(props) {
  var theme = props.theme;
  var effects = theme.effects;
  return {
    root: {
      borderRadius: effects.roundedCorner2
    },
    close: {
      background: 'transparent',
      borderRadius: "0 " + effects.roundedCorner2 + " " + effects.roundedCorner2 + " 0"
    }
  };
};